module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading || _vm.term == null) ? _c('loading') : _c('div', {
    staticClass: "page--period"
  }, [_c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v(_vm._s(_vm.salutation) + " "), _c('small', [_vm._v(_vm._s(_vm.subheading))])]), _c('p', [_vm._v(_vm._s(_vm.intro))]), (!_vm.isCurrent && !_vm.isTeacher) ? _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" vraag eerst even aan je docent of je vast aan deze opdrachten mag werken. Ga naar "), _c('router-link', {
    attrs: {
      "to": {
        name: 'period'
      }
    }
  }, [_vm._v("jouw opdrachtenlijst")]), _vm._v(" om de opdrachten van de huidige periode te bekijken.\n        ")], 1) : _vm._e(), _c('hr')]), (_vm.assignments.length) ? _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Welke wil je het eerst maken?")])]) : _vm._e(), _c('transition-group', {
    staticClass: "assignments",
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "progress": _vm.progress(assignment),
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "ignoreProgress": _vm.ignoreProgress,
        "disable": _vm.isDemo && !assignment.demo
      }
    })
  })), (_vm.retakeAssignments.length > 0 && !_vm.ignoreProgress && _vm.isCurrent) ? _c('div', {
    staticClass: "assignments"
  }, [_c('hr'), _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opnieuw inleveren")])]), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.retakeAssignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "disable": _vm.isDemo && !assignment.demo,
        "progress": _vm.progress(assignment)
      }
    })
  }))], 1) : _vm._e(), (_vm.overdueAssignments.length > 0 && !_vm.ignoreProgress && _vm.isCurrent) ? _c('div', {
    staticClass: "assignments"
  }, [_c('hr'), _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Nog niet afgemaakt")])]), _c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "insertion-bottom",
      "appear": ""
    }
  }, _vm._l((_vm.overdueAssignments), function(assignment) {
    return _c('assignment-route', {
      key: assignment.id,
      attrs: {
        "assignment": assignment,
        "user": _vm.user,
        "disableIfUnfinished": _vm.isInspectingStudent,
        "disable": _vm.isDemo && !assignment.demo,
        "progress": _vm.progress(assignment)
      }
    })
  }))], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379d7d32","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Period.vue
// module id = DXVi
// module chunks = 1